import { Component, OnDestroy, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { Dialog } from '../../interfaces/create-dialog.interface';
import { AutoUnsubscribe } from '../../decorators/auto-unsubscribe.decorator';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ManageTeamComponent } from '../manage-team/manage-team.component';

@AutoUnsubscribe()
@Component({
  standalone: true,
  selector: 'app-manage-team-dialog',
  templateUrl: './manage-team-dialog.component.html',
  styleUrls: ['./manage-team-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatButtonModule,
    MatIconModule,
    MatDialogModule,
    ManageTeamComponent,
  ],
})
export class ManageTeamDialogComponent implements OnDestroy {
  data = inject<Dialog>(MAT_DIALOG_DATA);


  // eslint-disable-next-line
  ngOnDestroy() {}
}
